export const SET_AUTH = 'SET_AUTH'
export const LOGOUT = 'LOGOUT'
